// extracted by mini-css-extract-plugin
export default {"editor":"AddressPage_editor__-UU1C"};